import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { convertHtmlToReact } from '@hedgedoc/html-to-react';
import { forwardRef, memo, useMemo } from 'react';
import { StyledImageTemplateWrapper } from './SVGCard.style';
export const SVGCard = memo(forwardRef(function SVGCard({ title, details, onClick }, ref) {
    const SVGDetails = details;
    const defs = useMemo(() => (SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.defs) || '', [SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.defs]);
    const content = useMemo(() => (SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.content) || '', [SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.content]);
    return (_jsx(StyledImageTemplateWrapper, { onClick: () => onClick({
            source: '',
            action: 'click',
            details: {
                name: title,
                numberOfPhotos: SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.numberOfPhotos,
            },
        }), ref: ref, children: (SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.defs) && (SVGDetails === null || SVGDetails === void 0 ? void 0 : SVGDetails.content) && (_jsxs("svg", { width: SVGDetails.width, height: SVGDetails.height, children: [_jsx("defs", { children: convertHtmlToReact(defs) }), convertHtmlToReact(content)] })) }));
}));
//# sourceMappingURL=SVGCard.js.map